// extracted by mini-css-extract-plugin
export var col = "TwoColTextContent-module--col--KnoJf";
export var colBody = "TwoColTextContent-module--colBody--w9sqA";
export var cols = "TwoColTextContent-module--cols--Jz3mi";
export var root = "TwoColTextContent-module--root--zwxhv";